import { useState } from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { Modal } from '@components/ui';

export function PhoneFormatHelp() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center text-secondary-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
        aria-label="Ayuda sobre el formato de teléfono"
        title="¿Cómo escribir el teléfono?"
      >
        <QuestionMarkCircleIcon className="h-4 w-4" />
      </button>

      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="¿Cómo escribir el teléfono?"
        size="md"
      >
        <div className="space-y-5 text-sm text-secondary-700 dark:text-secondary-200">
          <section>
            <h4 className="font-semibold text-secondary-900 dark:text-white mb-2">
              Panamá
            </h4>
            <p className="mb-2">Escribe el número así:</p>
            <div className="space-y-2 pl-1">
              <code className="font-mono bg-secondary-100 dark:bg-secondary-700 px-3 py-1 rounded inline-block">
                6789-1234
              </code>
              <span className="text-secondary-500 ml-2">para celular</span>
            </div>
            <div className="space-y-2 pl-1 mt-1">
              <code className="font-mono bg-secondary-100 dark:bg-secondary-700 px-3 py-1 rounded inline-block">
                234-5678
              </code>
              <span className="text-secondary-500 ml-2">para fijo</span>
            </div>
          </section>

          <section className="border-t border-secondary-200 dark:border-secondary-700 pt-4">
            <h4 className="font-semibold text-secondary-900 dark:text-white mb-2">
              Extranjero
            </h4>
            <p className="mb-2">Escribe el número así:</p>
            <div className="space-y-2 pl-1">
              <code className="font-mono bg-secondary-100 dark:bg-secondary-700 px-3 py-1 rounded inline-block">
                +1 202-555-0147
              </code>
            </div>
            <div className="space-y-2 pl-1 mt-1">
              <code className="font-mono bg-secondary-100 dark:bg-secondary-700 px-3 py-1 rounded inline-block">
                +52 55 1234-5678
              </code>
            </div>
            <div className="space-y-2 pl-1 mt-1">
              <code className="font-mono bg-secondary-100 dark:bg-secondary-700 px-3 py-1 rounded inline-block">
                +57 300-123-4567
              </code>
            </div>
          </section>
        </div>
      </Modal>
    </>
  );
}
